import type { Copy } from "../types";

export const cs: Copy = {
    seo: {
      title: "Kalkulačka stáří vozidla | kontrola podle roku a měsíce",
      description:
        "Zkontrolujte přesný věk vozidla podle roku výroby a volitelného měsíce. Zobrazte roky, měsíce, dny, celkové dny a milníky v jedné přehledné kalkulačce.",
      keywords: [
        "kalkulačka stáří vozidla",
        "stáří auta",
        "stáří vozidla podle roku",
        "rok výroby auta",
        "měsíc výroby vozidla",
        "jak staré je moje auto",
        "kontrola stáří vozidla",
        "kalkulačka stáří RC",
        "kalkulačka data vozidla",
        "kalkulačka stáří auta podle měsíce",
        "alternativa mParivahan",
        "alternativa Parivahan",
        "kalkulačka stáří vozidla RTO",
        "kontrola stáří registrace auta",
        "stáří registrace vozidla",
      ],
      faq: [
        {
          question: "Co tato kalkulačka dělá?",
          answer:
            "Počítá přesný věk vozidla z vybraného roku výroby a volitelného měsíce a ukáže roky, měsíce, dny i informace o milnících.",
        },
        {
          question: "Proč je měsíc volitelný?",
          answer:
            "Volba měsíce zpřesňuje výpočet stáří. Když měsíc vynecháte, aplikace použije leden vybraného roku.",
        },
        {
          question: "Mohu vybrat budoucí rok nebo měsíc?",
          answer:
            "Ne. Budoucí roky jsou zablokované a budoucí měsíce jsou deaktivované, když je vybraný rok ten aktuální.",
        },
      ],
    },
    headerTagline: "Pomůcka pro vozidla",
    headerTitle: "Kalkulačka stáří auta",
    reset: "Resetovat",
    switchToLight: "Přepnout na světlý režim",
    switchToDark: "Přepnout na tmavý režim",
    languageLabel: "Jazyk",
    languageEnglish: "Angličtina",
    languageHindi: "Hindština",
    heroEyebrow: "Stáří auta přehledně",
    heroTitle: "Čistý nástroj pro věk vozidla.",
    heroDescription: "Vyberte rok výroby. Měsíc přidejte jen tehdy, když chcete přesnější výsledek.",
    yearSelectLabel: "Rok výroby",
    monthSelectLabel: "Měsíc výroby",
    includeMonthLabel: "Zahrnout konkrétní měsíc pro větší přesnost",
    includeMonthNote: "Když měsíc nezadáte, pro výpočet se použije leden.",
    yearOnlyBadge: "Pouze rok",
    yearMonthBadge: "Rok + měsíc",
    yearPlaceholder: "Vybrat rok",
    monthPlaceholder: "Vybrat měsíc",
    inputTitle: "Rok výroby",
    inputLabel: "Rok výroby",
    blockedDateNote: "Budoucí roky jsou zablokované.",
    result: "Výsledek",
    vehicleAgeLead: "Vaše vozidlo je",
    asOfToday: "K dnešnímu dni",
    years: "Roky",
    months: "Měsíce",
    days: "Dny",
    totalDays: (count) => `${count.toLocaleString("en-IN")} celkem dní`,
    ageLabels: { almostNew: "Skoro nové", modern: "Moderní", mature: "Zralejší", classic: "Klasické" },
    estimatedValue: {
      high: "Vysoký potenciál dalšího prodeje",
      healthy: "Dobré držení hodnoty",
      moderate: "Mírné znehodnocení",
      collector: "Může růst zájem sběratelů",
    },
    maintenanceTitle: "Údržba",
    maintenance: {
      routine: "Běžný servis a péče OEM",
      watch: "Sledujte brzdy, kapaliny a pneumatiky",
      plan: "Plánujte opotřebení a kontroly",
      specialized: "Specializovaná údržba je důležitější",
    },
    registrationTitle: "Registrace",
    registration: {
      collector: "V některých regionech může platit sběratelský režim",
      classic: "V některých regionech může platit klasická registrace",
      standard: "Počítejte se standardními obnovami a místními kontrolami",
      regular: "Obvykle platí běžná registrace",
    },
    upcomingMilestoneTitle: "Příští milník",
    milestoneTimelineTitle: "Časová osa milníků",
    milestoneRemaining: ({ label, days }) => `${label} za ${days.toLocaleString("cs-CZ")} dní`,
    reached: "Dosaženo",
    upcoming: "Nadcházející",
    allMilestonesReachedTitle: "Všechny uvedené milníky byly dosaženy",
    allMilestonesReachedBody: "Toto vozidlo už překročilo rozsah milníků zobrazený v aplikaci.",
    copySummary: "Kopírovat souhrn",
    shareResult: "Sdílet výsledek",
    resetMessage: "Kalkulačka byla resetována",
    summaryCopied: "Souhrn zkopírován do schránky",
    clipboardFailed: "Přístup ke schránce selhal",
    emptyTitle: "Pro úplný rozpis vyberte rok výroby",
    emptyDescription:
      "Po výběru roku uvidíte přesný věk, celkový počet dní, poznámky k údržbě, klasický status i časování milníků.",
    shareTitle: "Kalkulačka stáří vozidla",
    summary: ({ label, years, months, days, asOf }) =>
      `Moje vozidlo má datum výroby ${label} a k ${asOf} je staré ${years} let, ${months} měsíců a ${days} dní.`,
    milestones: {
      1: { label: "První rok", note: "Užitečné pro záruku a plánování servisu." },
      3: { label: "Tři roky", note: "Běžný bod pro prodej a změny hodnoty." },
      5: { label: "Pět let", note: "Dobrá chvíle pro hlubší rozpočet údržby." },
      10: { label: "Deset let", note: "Starší součásti si zaslouží větší pozornost." },
      15: { label: "Patnáct let", note: "V mnoha regionech začíná klasické zacházení." },
      25: { label: "Pětadvacet let", note: "Může být zajímavé pro sběratele a dovoz." },
    },
  };
